import "@sourceflow-uk/job-search/dist/bundle.css";
import Search from "@/assets/Search.svg";
import JobSearch from "@sourceflow-uk/job-search";
import JobType from "@/../.sourceflow/jobs-Contract Type.json";
import Specialisms from "@/../.sourceflow/jobs-Specialisms.json";
import Consultants from "@/../.sourceflow/jobs-Consultants.json";
import InternalJobs from "@/../.sourceflow/jobs-Internal Jobs.json";
import JobLocations from "@/../.sourceflow/jobs-Locations.json";
import { faCheckSquare, faSquare } from "@fortawesome/free-regular-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
// import Sector from "@/../.sourceflow/jobs-Sector.json";
import PropTypes from "prop-types";
import { Container, Row, FormCheck, Stack } from "react-bootstrap";
import { CTA } from "@/ui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classes from "./styles.module.scss";
import clsx from "classnames";
import JobCard from "../JobCard";
import DiscoverScroll from "../DiscoverScroll";
import Breadcrumb from "../Breadcrumb";

function Result({}) {
  const interval = setInterval(checkForStrongElement, 1);

  function checkForStrongElement() {
    const totalCountsElement = document.querySelector(".js-total-count");

    if (!totalCountsElement) return;
    const strongElement = totalCountsElement.querySelector("strong");

    if (strongElement) {
      clearInterval(interval);
    }

    boldNumber();
  }

  function boldNumber() {
    const totalCountsElement = document.querySelector(".js-total-count");

    if (!totalCountsElement) return;

    const textContent = totalCountsElement.textContent;

    const words = textContent.split(" ");
    const lastWord = words[1];
    const numberPart = parseInt(lastWord, 10);

    totalCountsElement.innerHTML = textContent.replace(lastWord, `<strong>${numberPart}</strong>`);
  }

  return <></>;
}

export default function JobsFeed({ className, sector, changeURLOnFilterChange }) {
  return (
    <div className={clsx(classes.feed)} style={{ paddingTop: "60px" }}>
      <div style={{ padding: "0 60px" }}>
        <Breadcrumb label="Find Your Next Job" />
      </div>
      <div className={classes.hero}>
        <div className={classes.header}>
          <h1 className={classes.header_title}>
            FIND YOUR NEXT JOB <div className={classes.header_title_block} />
          </h1>
        </div>
        <div className={classes.search_placeholder}></div>
        <div className={classes.scroll}>
          <DiscoverScroll />
        </div>
      </div>
      <JobSearch
        options={{
          jobsUrl: "/jobs/",
          urlFilters: {
            mode: "active",
            jobCategories: [Specialisms, Consultants, JobType, JobLocations, InternalJobs],
            changeURLOnFilterChange: changeURLOnFilterChange,
          },
          searchInput: {
            queryInput: true,
            locationInput: true,
          },
          searchFiltersOptions: {
            showResetSearchButton: true,
            topLevelCategoryOrder: ["Contract Type", "Specialisms", "Internal Jobs"],
            nestedCategories: [Specialisms],
            filterFoldDepth: 0,
            filterUnselectedElement: <FontAwesomeIcon size="xl" icon={faSquare} />,
            filterSelectedElement: <FontAwesomeIcon size="xl" icon={faCheckSquare} />,
            filterFoldElement: <FontAwesomeIcon size="xl" icon={faAngleDown} />,
            categorySort: {
              Specialisms: { key: "name", direction: "asc" },
              Consultants: { key: "name", direction: "asc" },
            },
            exclude: {
              "2a6e8a62-0ea6-42ae-97de-4fe4099dc64a": true,
              "6d357999-3024-4299-bacd-3aac7e36e953": true,
              "a2c3d5cd-7fe0-4b30-b863-007cc65919a4": true,
              "5dd1c75d-e576-49e4-8e06-58c6cdebae5a": true,
              "Job Roles": true,
            },
            filterUnselectedElement: <FormCheck />,
            filterSelectedElement: <FormCheck checked />,
            // exclude: {
            //   "a82e2fc2-7013-4836-98aa-02667db9d824": true,
            //   "3186657c-e89c-4a6f-9157-35eb7fe0b379": [sector],
            // },
          },
          searchResults: ({ results }) =>
            results && (
              <>
                <Row>
                  {results.map((job, index) => (
                    <div key={index} className="list-item">
                      <JobCard job={job.job} />
                      <Result results={results}></Result>
                    </div>
                  ))}
                </Row>
              </>
            ),
        }}
        translations={{
          "filters.toggleButtonText": "FILTER BY",
          "searchResults.resultsTotalCount": "Search {{count}} Vacancies",
          "searchResults.buttonText": "View job",
          "button.text": (
            <Stack className="flex-row align-items-center justify-content-center px-3" gap={2}>
              <Search />
            </Stack>
          ),
        }}
      />
    </div>
  );
}

JobsFeed.defaultProps = {
  className: "py-4 py-md-5",
  sector: null,
  changeURLOnFilterChange: true,
};

JobsFeed.propTypes = {
  className: PropTypes.string,
  sector: PropTypes.string,
};
